export default "__VITE_ASSET__BTUfFfaf__"